import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { bounceCastle } from '../../../interfaces/bounce-castle';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ImageCarousel } from '../../image-carousel/image-carousel.component';
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'app-bouncy-castle',
  standalone: true,
  imports: [MatCardModule,
    MatGridListModule,
    CommonModule,
    MatButtonModule,
    TranslatePipe],
  templateUrl: './bouncy-castle.component.html',
  styleUrl: './bouncy-castle.component.scss',
})
export class BouncyCastleComponent {

  constructor(public dialog: MatDialog) { }

  openDialog(castle: bounceCastle): void {
    this.dialog.open(ImageCarousel, {
      maxHeight: '480px',
      maxWidth: '800px',
      autoFocus: false,
      data: castle
    });
  }
  bounceCastles: bounceCastle[] = [
    {
      name: "bounceCastle.Pirateship",
      size: "6.2m x 4m x 4m",
      weight: "~110kg",
      fan: "230V",
      engine: "1,1kW",
      price: "230",
      fraction: "00",
      features: "bounceCastle.Slide",
      maxPeople: "bounceCastle.Max.10Personen",
      img: ["Piratenschiff1.png", "Piratenschiff2.png", "Piratenschiff3.png", "Piratenschiff4.png", "Piratenschiff5.png"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.Riesenclown",
      size: "6m x 5m x 5m",
      weight: "~140kg",
      fan: "230V",
      engine: "1,1kW",
      price: "215",
      fraction: "00",
      features: "bounceCastle.Sonnenschutz",
      maxPeople: "bounceCastle.Max.15Personen",
      img: ["RiesenClown.png"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.Unicorn",
      size: "4.6m x 4m x 3.5m",
      weight: "~110kg",
      fan: "230V",
      engine: "1,1kW",
      price: "180",
      fraction: "00",
      features: "bounceCastle.Rutschen\\nSonnenschutz",
      maxPeople: "bounceCastle.Max.6Personen",
      img: ["Einhorn1.png", "Einhorn2.png", "Einhorn3.png", "Einhorn4.png"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.Gorilla",
      size: "4.6m x 4m x 3.5m",
      weight: "~110kg",
      fan: "230V",
      engine: "1,1kW",
      price: "180",
      fraction: "00",
      features: "bounceCastle.Rutschen\\nSonnenschutz\\nBocksack",
      maxPeople: "bounceCastle.Max.6Personen",
      img: ["Gorilla1.png", "Gorilla2.png", "Gorilla3.png", "Gorilla4.png"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.Multiplay",
      size: "5m x 4m x 4m",
      weight: "~150kg",
      fan: "230V",
      engine: "1,1kW",
      price: "209",
      fraction: "00",
      features: "bounceCastle.Rutschen\\nBoxsack",
      maxPeople: "bounceCastle.Max.10Personen",
      img: ["MultiplayElefant.png", "MultiplayElefant2.jpg", "MultiplayElefant3.jpg"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.ZirkusClown",
      size: "5m x 4m x 4m",
      weight: "~130kg",
      fan: "230V",
      engine: "1,1kW",
      price: "170",
      fraction: "00",
      features: "bounceCastle.Sonnenschutz",
      maxPeople: "bounceCastle.Max.10Personen",
      img: ["ZirkusClown.png", "ZirkusClown2.png", "ZirkusClown3.jpg"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.KlatschenderClown",
      size: "5m x 4m x 4,5m",
      weight: "~130kg",
      fan: "230V",
      engine: "1,1kW",
      price: "175",
      fraction: "00",
      features: "bounceCastle.Sonnenschutz",
      maxPeople: "bounceCastle.Max.10Personen",
      img: ["KlatschenderClown.png", "KlatschenderClown2.jpg", "KlatschenderClown3.jpg"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.MiniDschungel",
      size: "4m x 3m x 2,5m",
      weight: "~75kg",
      fan: "230V",
      engine: "1,1kW",
      price: "145",
      fraction: "00",
      features: "bounceCastle.Sonnenschutz",
      maxPeople: "bounceCastle.Max.6Personen",
      img: ["MiniDschungel.png", "MiniDschungel2.png", "MiniDschungel3.jpg"],
      cleaningFee: "40"
    },
    {
      name: "bounceCastle.BurgClown",
      size: "5m x 4m x 4m",
      weight: "~130kg",
      fan: "230V",
      engine: "1,1kW",
      price: "165",
      fraction: "00",
      features: "bounceCastle.Sonnenschutz",
      maxPeople: "bounceCastle.Max.10Personen",
      img: ["BurgClown1.png", "BurgClown2.png", "BurgClown3.png"],
      cleaningFee: "40"
    }
  ];
}
